/**
 * Authentication API Service
 * 
 * This module handles all authentication-related API calls
 * including login, user info, and token management.
 */

import axios from 'axios';
import API_CONFIG, { getAuthHeaders } from './config';

const authAPI = {
  /**
   * Login user with username and password
   * @param {string} username - User's username
   * @param {string} password - User's password
   * @returns {Promise<Object>} Login response with access token
   */
  async login(username, password) {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/api/auth/login`, {
      username,
      password
    }, {
      headers: API_CONFIG.HEADERS,
      timeout: API_CONFIG.TIMEOUT
    });
    return response.data;
  },

  /**
   * Get current user information
   * @param {string} token - JWT access token
   * @returns {Promise<Object>} User information
   */
  async getCurrentUser(token) {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/api/auth/me`, {
      headers: getAuthHeaders(token),
      timeout: API_CONFIG.TIMEOUT
    });
    return response.data;
  },

  /**
   * Check if user is authenticated
   * @param {string} token - JWT access token
   * @returns {Promise<boolean>} Authentication status
   */
  async checkAuth(token) {
    try {
      await this.getCurrentUser(token);
      return true;
    } catch (error) {
      return false;
    }
  }
};

export { authAPI };
